import moment from 'moment'

export default function isExpireSoon(time, days = '10') {
  const targetTime = moment(time)
  const expireSoonTime = moment().add(days, 'day')

  return targetTime.isBefore(expireSoonTime)
}
